module.exports = __webpack_public_path__ + "static/media/4.cf324b25.png";